document.addEventListener('DOMContentLoaded', () => {

  // Add event listener to mobile filter buttons
  const mobileFilterButtons = document.querySelectorAll('[data-mobile-main-filter-button]');
  
  mobileFilterButtons.forEach(mobileFilterBtn => {
    mobileFilterBtn.addEventListener('click', () => {
      const menuToFilter = mobileFilterBtn.dataset.mobileMainFilterButton;

      mobileFilterButtons.forEach(filterBtn => filterBtn.classList.remove('active'));
      mobileFilterBtn.classList.add('active');
      
      const menuGroups = document.querySelectorAll('[data-mobile-menu-group]');
      menuGroups.forEach(group => group.classList.remove('active'));
      
      const targetGroup = document.querySelector(`[data-mobile-menu-group="${menuToFilter}"]`);
      if (targetGroup) {
        targetGroup.classList.add('active');
      }
    });
  });

  const menuMobileIcon = document.querySelector('[data-menu-mobile-icon]');
  const menuMobileDrawer = document.querySelector('[data-menu-mobile-drawer]');
  const menuMobileDrawerClose = document.querySelector('[data-menu-mobile-close]');
  const menuMobileDrawerMask = document.querySelector('[data-menu-mobile-drawer-mask]');

  menuMobileIcon && menuMobileIcon.addEventListener('click', (e) => {
    e.preventDefault();
    document.body.classList.add('lock')
    menuMobileDrawer.classList.toggle('active');
    menuMobileDrawerMask.classList.toggle('active');

    // Find first mobile filter button and simulate click
    const firstMobileFilterBtn = document.querySelector('.mobile-main-filter-btn');
    if (firstMobileFilterBtn) {
      firstMobileFilterBtn.click();
    }
  })
  // Function to reset mobile menu internal state
  const resetMobileMenuInternalState = () => {
    // Reset all second level submenus
    const allSubmenuLists = document.querySelectorAll('[data-menu-mobile-submenu-list]');
    allSubmenuLists.forEach(submenu => submenu.classList.remove('active'));
    
    // Reset all third level submenus
    const allThirdLevelLists = document.querySelectorAll('[data-menu-mobile-third-level-list]');
    allThirdLevelLists.forEach(thirdLevel => thirdLevel.classList.remove('active'));
    
    // Reset filter buttons to first one
    const firstMobileFilterBtn = document.querySelector('.mobile-main-filter-btn');
    if (firstMobileFilterBtn) {
      mobileFilterButtons.forEach(filterBtn => filterBtn.classList.remove('active'));
      firstMobileFilterBtn.classList.add('active');
      
      const menuGroups = document.querySelectorAll('[data-mobile-menu-group]');
      menuGroups.forEach(group => group.classList.remove('active'));
      
      const menuToFilter = firstMobileFilterBtn.dataset.mobileMainFilterButton;
      const targetGroup = document.querySelector(`[data-mobile-menu-group="${menuToFilter}"]`);
      if (targetGroup) {
        targetGroup.classList.add('active');
      }
    }
  };

  menuMobileDrawerClose && menuMobileDrawerClose.addEventListener('click', (e) => {
    e.preventDefault();
    menuMobileDrawer.classList.remove('active');
    menuMobileDrawerMask.classList.remove('active');
    document.body.classList.remove('lock');
    // Reset state when the menu is closed
    resetMobileMenuInternalState();
  })
  menuMobileDrawerMask && menuMobileDrawerMask.addEventListener('click', (e) => {
    e.preventDefault();
    menuMobileDrawer.classList.remove('active');
    menuMobileDrawerMask.classList.remove('active');
    document.body.classList.remove('lock');
    // Reset state when the menu is closed
    resetMobileMenuInternalState();
  })


  const mobileOpenLevelElements = document.querySelectorAll('[data-menu-mobile-open-level]');
  mobileOpenLevelElements.forEach(openLevelEl => {
    openLevelEl && openLevelEl.addEventListener('click', (e) => {

      const backButton = openLevelEl.querySelector('[data-menu-mobile-back-button]')
      if (backButton && (e.target === backButton || backButton.contains(e.target))) return

      e.preventDefault();
      const menuLevel = openLevelEl.querySelector('[data-menu-mobile-submenu-list]');
      menuLevel && menuLevel.classList.add('active');
    })
  })

  const mobileChildLinks = document.querySelectorAll('[data-mega-menu-mobile-child-link]')

  mobileChildLinks.forEach(mobileLink => {
    if (!mobileLink) return
    mobileLink.addEventListener('click', (e) => {
      const href = mobileLink.getAttribute('href') || ''
      const isAnchor = href.trim().startsWith('#')
      if (!isAnchor) {
        e.preventDefault();
        // Close drawer immediately for visual feedback
        menuMobileDrawer && menuMobileDrawer.classList.remove('active');
        menuMobileDrawerMask && menuMobileDrawerMask.classList.remove('active');
        document.body.classList.remove('lock');
        // Reset state when navigating
        resetMobileMenuInternalState();
        window.location.href = href
      }
    })
  })

  const mobileBackLevelButton = document.querySelectorAll('[data-menu-mobile-back-button]');
  mobileBackLevelButton.forEach(backLevelBtn => {
    backLevelBtn && backLevelBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const menuLevel = backLevelBtn.parentElement
      menuLevel && menuLevel.classList.remove('active');
    })
  })

  // Handle third level menu opening
  const mobileOpenThirdLevelElements = document.querySelectorAll('[data-menu-mobile-open-third-level]');
  mobileOpenThirdLevelElements.forEach(openThirdLevelEl => {
    openThirdLevelEl && openThirdLevelEl.addEventListener('click', (e) => {
      e.preventDefault();
      
      const childId = openThirdLevelEl.dataset.childId;
      const submenuList = openThirdLevelEl.closest('[data-menu-mobile-submenu-list]');
      
      if (submenuList && childId) {
        // Hide all third level lists in this submenu
        const allThirdLevelLists = submenuList.querySelectorAll('[data-menu-mobile-third-level-list]');
        allThirdLevelLists.forEach(list => list.classList.remove('active'));
        
        // Show the corresponding third level list
        const targetThirdLevel = submenuList.querySelector(`[data-menu-mobile-third-level-list][data-child="${childId}"]`);
        if (targetThirdLevel) {
          targetThirdLevel.classList.add('active');
        }
      }
    })
  })

  // Handle third level back button
  const mobileBackThirdLevelButtons = document.querySelectorAll('[data-menu-mobile-back-third-level]');
  mobileBackThirdLevelButtons.forEach(backThirdLevelBtn => {
    backThirdLevelBtn && backThirdLevelBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const thirdLevelMenu = backThirdLevelBtn.parentElement
      thirdLevelMenu && thirdLevelMenu.classList.remove('active');
    })
  })

  // Handle third level sub-links
  const mobileSubLinks = document.querySelectorAll('[data-mega-menu-mobile-sub-link]')
  mobileSubLinks.forEach(mobileSubLink => {
    if (!mobileSubLink) return
    mobileSubLink.addEventListener('click', (e) => {
      const href = mobileSubLink.getAttribute('href') || ''
      const isAnchor = href.trim().startsWith('#')
      if (!isAnchor) {
        e.preventDefault();
        menuMobileDrawer && menuMobileDrawer.classList.remove('active');
        menuMobileDrawerMask && menuMobileDrawerMask.classList.remove('active');
        document.body.classList.remove('lock');
        // Reset state when navigating
        resetMobileMenuInternalState();
        window.location.href = href
      }
    })
  })

  // Handle third level image links
  const mobileSubImageLinks = document.querySelectorAll('.mega-menu-mobile-sub-link-image')
  mobileSubImageLinks.forEach(mobileSubImageLink => {
    if (!mobileSubImageLink) return
    mobileSubImageLink.addEventListener('click', (e) => {
      const href = mobileSubImageLink.getAttribute('href') || ''
      const isAnchor = href.trim().startsWith('#')
      if (!isAnchor) {
        e.preventDefault();
        menuMobileDrawer && menuMobileDrawer.classList.remove('active');
        menuMobileDrawerMask && menuMobileDrawerMask.classList.remove('active');
        document.body.classList.remove('lock');
        // Reset state when navigating
        resetMobileMenuInternalState();
        window.location.href = href
      }
    })
  })
  
});
